import { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';
import { getPhoneNumberValue } from './get-phone-number-value';

export const formatPhoneNumber = (phone = '') => {
  if (!phone) return '';

  if (!phone.includes('+')) phone = `+${phone}`;

  const phoneNumber = formatPhoneNumberIntl(phone);
  const phoneNumberLength = phoneNumber.split(' ').join('').length;

  if (phoneNumberLength === phone.length) phone = phoneNumber;

  return phone;
};

export const maskPhoneNumber = (phoneNumber = '') => {
  phoneNumber = getPhoneNumberValue(phoneNumber);

  if (phoneNumber.length) phoneNumber = `+${getPhoneNumberValue(phoneNumber)}`;
  else phoneNumber = '';

  if (isValidPhoneNumber(phoneNumber)) {
    const maskedPhoneNumber = formatPhoneNumberIntl(phoneNumber);
    const phoneNumberLength = maskedPhoneNumber.split(' ').join('').length;

    if (phoneNumberLength === phoneNumber.length) phoneNumber = maskedPhoneNumber;
  }

  return phoneNumber;
};
